  document.addEventListener("DOMContentLoaded", function() {
    const faqItems = document.querySelectorAll("#faq-section .faq-item");

    faqItems.forEach(item => {
      const question = item.querySelector(".faq-question");
      const answer = item.querySelector(".faq-answer");

      question.addEventListener("click", () => {
        const isActive = question.classList.contains("active");

        // Close all
        faqItems.forEach(i => {
          i.querySelector(".faq-question").classList.remove("active");
          i.querySelector(".faq-answer").style.maxHeight = null;
        });

        // Open current if not already active
        if (!isActive) {
          question.classList.add("active");
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  });